export default {
  INVESTED_PAGE_REQUESTED: 'INVESTED_PAGE_REQUESTED',
  INVESTED_PAGE_SUCCEEDED: 'INVESTED_PAGE_SUCCEEDED',
  INVESTED_PAGE_FAILED: 'INVESTED_PAGE_FAILED',
};
